import React from "react";
import { Link, useParams } from "react-router-dom";

export default function Banner(props) {
  const params = useParams();
  const theme_color = localStorage.getItem("theme");
  return (
    <>
      <section className="banner">
        <div className="container">
          <h2 className="text-center">{props.title}</h2>
          <div className="breadcrumps d-flex align-items-center">
            {props.is_single_blog && (
              <>
                <Link to="/" className="text-white">
                  Home
                </Link>
                <span className="text-white mx-2">/</span>
              </>
            )}
            <Link
              to={"/category/" + props.subtitle.toLowerCase().replace(" ", "-")}
              className={"m-0 text-" + theme_color}
              style={{ textTransform: props.textTransform }}
            >
              {props.id !== params.id ? "-" : props.subtitle}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

Banner.defaultProps = {
  title: "The Venom Blog",
  subtitle: "Your source of great content",
  textTransform: "initial",
};
